<script setup lang="ts">
  defineOptions({
    name: 'ChatErrorToaster',
  })

  import { watch } from 'vue'

  import { useChatErrorToast } from '../../composables/useChatErrorToast'

  import { useChatsUIStore } from '../../stores/chats.ui-store'

  /**
   * Global surface for chat failures. Renders nothing.
   *
   * Mount as a direct child of `HLContentWrap` in each app's root container. Its setup runs below
   * the notification provider, which is what makes `useChatErrorToast` legal here — the root
   * container's own setup runs above the provider it renders and so cannot resolve it.
   *
   * Chat failures originate anywhere (profile popovers, member lists, deep links), so the chats
   * data layer records them on the UI store and this single listener surfaces them, rather than
   * every call site wiring up messaging of its own.
   */
  const uiStore = useChatsUIStore()

  const { notifyCreateConversationFailure } = useChatErrorToast()

  watch(
    () => uiStore.lastCreateConversationError,
    pending => {
      if (!pending) return

      notifyCreateConversationFailure(pending.error)
      // Synchronous flushing re-enters this watcher with null; the guard above ends that call.
      uiStore.clearCreateConversationError()
    },
    { flush: 'sync' }
  )
</script>

<template>
  <span class="hidden" aria-hidden="true" />
</template>
